import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  startAfter,
  where,
} from "firebase/firestore";
import { appFireStore, timestamp } from "../../firebase";
import { IsAlbum, IsAlbumUpload, IsPlatform } from "../../type/album";
import { useState } from "react";

export const useBoard = () => {
  const [documents, setDocuments] = useState<IsAlbum[]>();
  const collectionRef = collection(appFireStore, "Board");

  const getAllDocuments = async () => {
    const q = query(
      collection(appFireStore, "Board"),
      where("isVisible", "==", true),
      orderBy("createdTime", "desc"),
      limit(10)
    );
    console.log("FireStore Access");

    const data = await getDocs(q);
    let result: any[] = [];
    data.forEach((doc) => {
      result.push({ ...doc.data(), id: doc.id });
    });

    // const last = data.docs[data.docs.length - 1];
    // setLastVisible(last);

    // const next = query(
    //   collectionRef,
    //   startAfter(lastVisible),
    //   where("isVisible", "==", true),
    //   orderBy("createdTime", "desc"),
    //   limit(10)
    // );

    // const nextData = await getDocs(next);
    // const newData = data.docs.map((doc) => ({ ...doc.data() }));

    return result;
  };

  // 수정 예정
  const getDocumentByUidRealTime = (uid: string, level: number) => {
    const q = query(
      collection(appFireStore, "Board"),
      where("uid", "==", uid),
      orderBy("createdTime", "desc"),
      limit(22)
    );
    console.log("FireStore Access");
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        let result: any[] = [];
        querySnapshot.forEach((doc) => {
          result.push({ ...doc.data(), id: doc.id });
        });

        let array = [
          {
            id: "write",
            title: "",
            url: "",
            createdTime: "",
            platform: "",
            uid: uid,
            username: "",
            content: [],
            isVisible: false,
          },
        ];

        setDocuments(
          result.length >= 2 + level ? result : result.concat(array)
        );
      },
      (error) => {
        console.log(error.message);
      }
    );
  };

  const getDocumentsByUid = async (uid: string) => {
    const q = query(
      collection(appFireStore, "Board"),
      where("isVisible", "==", true),
      where("uid", "==", uid),
      orderBy("createdTime", "desc"),
      limit(10)
    );
    console.log("FireStore Access");
    const data = await getDocs(q);
    let result: any[] = [];
    data.forEach((doc) => {
      result.push({ ...doc.data(), id: doc.id });
    });

    return result;
  };

  const getDocumentsByPlatform = async (platform: IsPlatform) => {
    const q = query(
      collection(appFireStore, "Board"),
      where("isVisible", "==", true),
      where("platform", "==", platform),
      orderBy("createdTime", "desc"),
      limit(10)
    );
    console.log("FireStore Access");
    const data = await getDocs(q);
    let result: any[] = [];
    data.forEach((doc) => {
      result.push({ ...doc.data(), id: doc.id });
    });

    return result;
  };

  const getDocumentsByVocal = async (vocal: string) => {
    const q = query(
      collection(appFireStore, "Board"),
      where("isVisible", "==", true),
      where("vocalList", "array-contains", vocal),
      orderBy("createdTime", "desc"),
      limit(10)
    );
    console.log(vocal);
    console.log("FireStore Access");
    const data = await getDocs(q);
    // console.log(data.docs);
    let result: any[] = [];
    data.forEach((doc) => {
      result.push({ ...doc.data(), id: doc.id });
    });
    console.log(result);
    return result;
  };

  const getDocumentById = async (id: string) => {
    const q = query(
      collection(appFireStore, "Board"),
      where("isVisible", "==", true),
      where("id", "==", id),
      orderBy("createdTime", "desc"),
      limit(10)
    );

    console.log("FireStore Access");
    const data = await getDocs(q);

    let result: any[] = [];
    data.forEach((doc) => {
      result.push({ ...doc.data(), id: doc.id });
    });
    console.log(result);
    return result;
  };

  const addDocument = async (
    album: IsAlbumUpload,
    uid: string,
    username: string
  ) => {
    const createdTime = timestamp.fromDate(new Date());

    if (album.id === "write") {
      // 신규 문서
      await addDoc(collectionRef, {
        ...album,
        createdTime,
        username: username,
        uid: uid,
      });
      return;
    }
    // 기존 문서
    await setDoc(
      doc(collectionRef, album.id),
      {
        ...album,
        createdTime,
      },
      { merge: true }
    );
  };

  const deleteDocument = async (id: string) => {
    console.log("Del: " + id);
    await deleteDoc(doc(collectionRef, id));
  };

  const privateToPublic = async (id: string, nextIsVisible: boolean) => {
    await setDoc(
      doc(collectionRef, id),
      {
        isVisible: nextIsVisible,
      },
      { merge: true }
    );
  };

  return {
    documents,
    getAllDocuments,
    getDocumentByUidRealTime,
    getDocumentsByPlatform,
    getDocumentsByUid,
    getDocumentsByVocal,
    getDocumentById,
    addDocument,
    deleteDocument,
    privateToPublic,
  };
};
